// extracted by mini-css-extract-plugin
export default {"icon":"FullPageLoading_icon__xKxuD","rotation":"FullPageLoading_rotation__RehtM","mainDiv":"FullPageLoading_mainDiv__eFc6q"};